import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { LanguageProvider } from "./context/LanguageContext";
import { MessagesProvider } from "./context/MessagesContext";
import "./styles/global.css";
import "./styles/Buttons.css";
import "./styles/Navbar.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <LanguageProvider>
      <MessagesProvider>
        <App />
      </MessagesProvider>
    </LanguageProvider>
  </BrowserRouter>
);